// Apple Human Interface Guidelines 主题配置
export const theme = {
  colors: {
    // 主色调 - 无彩灰 + 默红点缀（冷淡基准）
    primary: '#A9443F',
    primaryDark: '#873331',
    primaryLight: '#CC756E',

    // 辅助色 / 状态色（整体压低饱和度）
    secondary: '#9E9E9E',
    success: '#3BA776',
    warning: '#F4B41A',
    error: '#D1433F',
    info: '#4A90E2',

    // 中性色（黑白灰）
    text: {
      primary: '#202124',
      secondary: '#80838A',
      tertiary: '#B3B6BD',
      inverse: '#FFFFFF',
    },

    background: {
      default: '#FFFFFF',
      secondary: '#F5F5F5',
      tertiary: '#EDEDED',
    },

    border: {
      default: '#E0E0E0',
      light: '#E5E5E5',
      dark: '#BDBDBD',
    },
    surface: {
      base: '#FFFFFF',
      subtle: '#FAFAFA',
      elevated: '#FFFFFF',
      overlay: 'rgba(32, 33, 36, 0.45)',
      glass: 'rgba(255, 255, 255, 0.85)',
    },
    focusRing: 'rgba(169, 68, 63, 0.25)',
  },

  // 字体系统 - Apple 文本层级
  typography: {
    fontFamily: {
      primary: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      mono: 'Monaco, "Courier New", monospace',
    },
    fontSize: {
      // Apple 语义化层级
      largeTitle: '2.125rem', // 34pt
      title1: '1.75rem',     // 28pt
      title2: '1.375rem',    // 22pt
      title3: '1.25rem',     // 20pt
      headline: '1.0625rem', // 17pt
      body: '1.0625rem',     // 17pt
      subhead: '0.9375rem',  // 15pt
      footnote: '0.8125rem', // 13pt
      caption: '0.75rem',    // 12pt
      // 向后兼容
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeight: {
      tight: 1.25,
      normal: 1.5,
      relaxed: 1.75,
    },
  },

  // 间距系统 (8pt 基准)
  spacing: {
    xs: '0.25rem',   // 4px
    sm: '0.5rem',    // 8px
    md: '1rem',      // 16px
    lg: '1.5rem',    // 24px
    xl: '2rem',      // 32px
    '2xl': '3rem',   // 48px
    '3xl': '4rem',   // 64px
  },

  // 响应式断点
  breakpoints: {
    mobile: '0px',
    tablet: '750px',
    desktop: '990px',
  },

  // 圆角 - Apple 风格
  borderRadius: {
    none: '0',
    sm: '0.375rem',   // 6px
    md: '0.625rem',   // 10px
    lg: '0.75rem',    // 12px
    xl: '0.75rem',    // 12px
    full: '9999px',
  },

  // 阴影
  shadows: {
    sm: '0 1px 2px rgba(15, 23, 42, 0.04), 0 0 0 1px rgba(15, 23, 42, 0.03)',
    md: '0 8px 24px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04)',
    lg: '0 16px 40px rgba(15, 23, 42, 0.12), 0 2px 8px rgba(15, 23, 42, 0.05)',
    xl: '0 24px 56px rgba(15, 23, 42, 0.16), 0 4px 12px rgba(15, 23, 42, 0.08)',
  },

  // 过渡动画
  transitions: {
    fast: '180ms cubic-bezier(0.2, 0.8, 0.2, 1)',
    normal: '280ms cubic-bezier(0.2, 0.8, 0.2, 1)',
    slow: '420ms cubic-bezier(0.2, 0.8, 0.2, 1)',
  },
  motion: {
    duration: {
      instant: '120ms',
      fast: '180ms',
      normal: '280ms',
      slow: '420ms',
    },
    easing: {
      standard: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
      emphasize: 'cubic-bezier(0.22, 1, 0.36, 1)',
      exit: 'cubic-bezier(0.4, 0, 1, 1)',
    },
  },
  layout: {
    contentMaxWidth: '1200px',
    wideMaxWidth: '1400px',
  },

  // Z-index层级
  zIndex: {
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modalBackdrop: 1040,
    modal: 1050,
    popover: 1060,
    tooltip: 1070,
  },
};

export type Theme = typeof theme;
